import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form as FormikForm } from 'formik';
import { Button } from 'react-bootstrap5';
import axios from 'axios';

import routes from 'app/routes';
import HorizontalFileField from 'components/new_ui/Form/HorizontalFileField';
import SubmitButton from 'components/Widgets/SubmitButton';
import Modal from 'components/new_ui/Modal/Modal';
import Alert from 'components/new_ui/Alerts/alert';

export default function NewModal({
  show, assessments, setAssessments, onCloseClick,
}) {
  const onSubmitHundler = (values, { setSubmitting }) => {
    const formData = new FormData();

    Object.keys(values).forEach((key) => {
      formData.append(`assessment[${key}]`, values[key] === null ? '' : values[key]);
    });

    axios
      .post(routes.api.members.assessments.create, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        setAssessments([response.data.data, ...assessments]);
        setSubmitting(false);
        onCloseClick(() => {
          Alert({
            text: 'External Assessment has been successfully uploaded!',
          });
        });
      });
  };

  return (
    <Modal
      header="Select a file to share with your coach"
      show={show}
      onHide={() => onCloseClick()}
    >
      <Formik
        initialValues={{
          attachment: null,
        }}
        onSubmit={onSubmitHundler}
      >
        {({ isSubmitting, values }) => (
          <FormikForm className="needs-validation" noValidate="">
            <HorizontalFileField
              name="attachment"
              fileTypes={['PDF', 'DOC', 'XDOC']}
              showPreview={false}
              disabled={isSubmitting}
            />

            <footer>
              <Button
                variant="outline-primary"
                disabled={isSubmitting}
                onClick={() => onCloseClick()}
              >
                Cancel
              </Button>

              <SubmitButton
                loading={isSubmitting}
                disabled={values.attachment === null}
              >
                Upload
              </SubmitButton>
            </footer>
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}

NewModal.propTypes = {
  show: PropTypes.bool.isRequired,
  assessments: PropTypes.arrayOf(PropTypes.object),
  setAssessments: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};

NewModal.defaultProps = {
  assessments: [],
};
